if(!customElements.get('solar-camping')){
    customElements.define('solar-camping',class SolarCamping extends HTMLElement{
        constructor(){
            super()
            this.init()
        }

        init(){
            const _this = this
            this.closeBtn = this.querySelector('.icon-mask-close')
            this.iconMaskContent = _this.querySelector('.icon-mask-content')
            this.closeBtn.addEventListener('click',()=>{
                _this.iconMaskContent.classList.add('visibility-hidden')
                _this.querySelector('.solar-camping-left').classList.remove('z-index-10')
            })
            this.querySelector('.pc-icon-open').addEventListener('click',()=>{
                _this.iconMaskContent.classList.remove('visibility-hidden')
            })
            this.querySelector('.mobile-icon-open').addEventListener('click',()=>{
                _this.querySelector('.solar-camping-left').classList.add('z-index-10')
            })
        }
    })
}